/**
 * Generated file, do not edit directly!
 */

/** Animations enhance user experience by assisting users in focusing their attention, conveying spatial relationships, and expressing our brand's tone. */

/** Use for opening or expanding elements. */
const Open = {
  Duration: {
    /** Value: 0.17. */
    Fast: 0.17,
    /** Value: 0.25. */
    Base: 0.25,
    /** Value: 0.4. */
    Slow: 0.4,
  },
  /** Value: [ 0, 0,0.2,1 ]. */
  Easing: [0, 0, 0.2, 1],
};
/** Use for closing or collapsing elements. */
const Close = {
  Duration: {
    /** Value: 0. */
    Fast: 0,
    /** Value: 0.17. */
    Base: 0.17,
    /** Value: 0.25. */
    Slow: 0.25,
  },
  /** Value: [ 0.5, 0,1,1 ]. */
  Easing: [0.5, 0, 1, 1],
};
/** Use for sliding elements into view. */
const SlideIn = {
  Duration: {
    /** Value: 0.2. */
    Fast: 0.2,
    /** Value: 0.3. */
    Base: 0.3,
    /** Value: 0.4. */
    Slow: 0.4,
  },
  /** Value: [ 0, 0,0.2,1 ]. */
  Easing: [0, 0, 0.2, 1],
};
/** Use for sliding elements out of view. */
const SlideOut = {
  Duration: {
    /** Value: 0.15. */
    Fast: 0.15,
    /** Value: 0.25. */
    Base: 0.25,
    /** Value: 0.35. */
    Slow: 0.35,
  },
  /** Value: [ 0.8, 0,0.5,1 ]. */
  Easing: [0.8, 0, 0.5, 1],
};
/** Use for fading in elements. */
const FadeIn = {
  Duration: {
    /** Value: 0.15. */
    Fast: 0.15,
    /** Value: 0.25. */
    Base: 0.25,
    /** Value: 0.35. */
    Slow: 0.35,
  },
  /** Value: [ 0.5, 0,1,1 ]. */
  Easing: [0.5, 0, 1, 1],
};
/** Use for fading out elements. */
const FadeOut = {
  Duration: {
    /** Value: 0.15. */
    Fast: 0.15,
    /** Value: 0.25. */
    Base: 0.25,
    /** Value: 0.35. */
    Slow: 0.35,
  },
  /** Value: [ 0, 0,0.2,1 ]. */
  Easing: [0, 0, 0.2, 1],
};
/** Use for hovering interactive elements. */
const Hover = {
  Duration: {
    /** Value: 0.15. */
    Base: 0.15,
  },
  /** Value: [ 0, 0,0.2,1 ]. */
  Easing: [0, 0, 0.2, 1],
};
/** Use for progressively revealing or animating elements. */
const StaggeredMotion = {
  Duration: {
    /** Value: 0.25. */
    Fast: 0.25,
    /** Value: 0.35. */
    Base: 0.35,
    /** Value: 0.4. */
    Slow: 0.4,
  },
  Offset: {
    /** Value: 0.02. */
    Fast: 0.02,
    /** Value: 0.03. */
    Base: 0.03,
    /** Value: 0.05. */
    Slow: 0.05,
  },
  /** Value: [ 0, 0,0.2,1 ]. */
  Easing: [0, 0, 0.2, 1],
};
/** Use for expanding and collapsing elements such as accordions or expandables. */
const ExpandCollapse = {
  Duration: {
    /** Value: 0.25. */
    Fast: 0.25,
    /** Value: 0.4. */
    Base: 0.4,
    /** Value: 0.6. */
    Slow: 0.6,
  },
  /** Value: [ 0.4, 0,0.2,1 ]. */
  Easing: [0.4, 0, 0.2, 1],
};
/** Use for elements changing position. */
const Move = {
  Duration: {
    /** Value: 0.15. */
    Fast: 0.15,
    /** Value: 0.4. */
    Base: 0.4,
    /** Value: 0.6. */
    Slow: 0.6,
  },
  /** Value: [ 0.4, 0,0.2,1 ]. */
  Easing: [0.4, 0, 0.2, 1],
};
/** Use for rescaling elements. */
const Rescale = {
  Duration: {
    /** Value: 0.17. */
    Fast: 0.17,
    /** Value: 0.25. */
    Base: 0.25,
    /** Value: 0.4. */
    Slow: 0.4,
  },
  /** Value: [ 0.4, 0,0.2,1 ]. */
  Easing: [0.4, 0, 0.2, 1],
};
export default {
  Open,
  Close,
  SlideIn,
  SlideOut,
  FadeIn,
  FadeOut,
  Hover,
  StaggeredMotion,
  ExpandCollapse,
  Move,
  Rescale,
};
